import { default as _91_46_46_46slug_93L6hVlZgiBhMeta } from "/opt/dasei/source/apps/home/pages/[...slug].vue?macro=true";
import { default as beratungoKJXRUSgH2Meta } from "/opt/dasei/source/apps/home/pages/beratung.vue?macro=true";
import { default as detailsk9E857EzfQMeta } from "/opt/dasei/source/apps/home/pages/details.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/opt/dasei/source/apps/home/pages/[...slug].vue")
  },
  {
    name: "beratung",
    path: "/beratung",
    meta: beratungoKJXRUSgH2Meta || {},
    component: () => import("/opt/dasei/source/apps/home/pages/beratung.vue")
  },
  {
    name: "details",
    path: "/details",
    meta: detailsk9E857EzfQMeta || {},
    component: () => import("/opt/dasei/source/apps/home/pages/details.vue")
  }
]